module.exports = __webpack_public_path__ + "img/book-09.acb05757.png";